"use client";

import { useCallback } from "react";
import Script from "next/script";
import type { User } from "@repo/ts";

type BotpressInstance = {
  init: (config: unknown) => void;
  on: (event: string, cb: () => void) => void;
  updateUser: (data: { data: Record<string, string> }) => void;
};

declare global {
  interface Window {
    botpress?: BotpressInstance;
  }
}

interface BotpressChatProps {
  user: User | null;
  crsReferenceNumber?: string;
}

export function BotpressChat({ user, crsReferenceNumber }: BotpressChatProps) {
  const handleLoad = useCallback(() => {
    if (!user) return;
    const bp = window.botpress;
    if (!bp || !user) return;

    bp.init({
      botId: "ac43f8a1-90d5-4f8b-9fed-0940be343df6",
      configuration: {
        version: "v2",
        botName: "Emma",
        botAvatar: "https://files.bpcontent.cloud/2026/02/19/08/20260219085812-1Q3BBM2Y.png",
        fabImage: "https://files.bpcontent.cloud/2026/02/19/08/20260219085812-1Q3BBM2Y.png",
        website: {},
        email: {},
        phone: {},
        termsOfService: {},
        privacyPolicy: {},
        color: "#3276EA",
        variant: "solid",
        headerVariant: "glass",
        themeMode: "light",
        fontFamily: "inter",
        radius: 2,
        feedbackEnabled: false,
        footer: "",
        soundEnabled: false,
        proactiveMessageEnabled: false,
        proactiveBubbleMessage: "Hi! 👋 Need help?",
        proactiveBubbleTriggerType: "afterDelay",
        proactiveBubbleDelayTime: 10,
        conversationHistory: false,
      },
      clientId: "e4214cb8-9610-4231-a1f4-ead0ec36bd21",
    });

    bp.on("webchat:initialized", () => {
      bp.updateUser({
        data: {
          crs_reference_number: crsReferenceNumber ?? "",
          crs_signature: process.env.NEXT_PUBLIC_BOTPRESS_CRS_SIGNATURE ?? "",
          email: user.email ?? "",
          name: user.name ?? "",
          preferred_language: navigator.language,
          domain: window.location.hostname,
          path: window.location.pathname,
        },
      });
    });
  }, [user, crsReferenceNumber]);

  if (!user) return null;

  return (
    <Script
      src="https://cdn.botpress.cloud/webchat/v3.3/inject.js"
      strategy="lazyOnload"
      onLoad={handleLoad}
    />
  );
}
